import { render, staticRenderFns } from "./ProjectsComponent.vue?vue&type=template&id=53f54984&scoped=true"
import script from "./ProjectsComponent.vue?vue&type=script&lang=js"
export * from "./ProjectsComponent.vue?vue&type=script&lang=js"
import style0 from "./ProjectsComponent.vue?vue&type=style&index=0&id=53f54984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f54984",
  null
  
)

export default component.exports